import { render, staticRenderFns } from "./ChangeUsernamePass.vue?vue&type=template&id=5523cbbb&scoped=true"
import script from "./ChangeUsernamePass.vue?vue&type=script&lang=js"
export * from "./ChangeUsernamePass.vue?vue&type=script&lang=js"
import style0 from "./ChangeUsernamePass.vue?vue&type=style&index=0&id=5523cbbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523cbbb",
  null
  
)

export default component.exports